import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { ILocationHardwareTenantOwnedItem } from '~/types/location/models'

const apiEntityPath = '/api/locationhardwaretenantowneditems'

export async function getLocationHardwareTenantOwnedItemsForLocation(
  id: string
) {
  const callingMn = getLocationHardwareTenantOwnedItemsForLocation.name
  const apiPath = `${apiEntityPath}/${id}`
  return httpGet<ILocationHardwareTenantOwnedItem[]>({ callingMn, apiPath })
}

export async function createLocationHardwareTenantOwnedItem(
  entity: ILocationHardwareTenantOwnedItem
) {
  const callingMn = createLocationHardwareTenantOwnedItem.name
  const apiPath = apiEntityPath
  return httpPost<ILocationHardwareTenantOwnedItem>({
    callingMn,
    apiPath,
    entity,
  })
}

export async function updateLocationHardwareTenantOwnedItem(
  entityData: Partial<ILocationHardwareTenantOwnedItem>,
  id: TEntityId
) {
  const callingMn = updateLocationHardwareTenantOwnedItem.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialILocationHardwareTenantOwnedItem =
    Partial<ILocationHardwareTenantOwnedItem>
  return httpPatchMerge<TPartialILocationHardwareTenantOwnedItem>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteLocationHardwareTenantOwnedItem(
  entityData: ILocationHardwareTenantOwnedItem
) {
  const callingMn = deleteLocationHardwareTenantOwnedItem.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
